import { Injectable } from '@angular/core';

import { Api } from './api';

@Injectable({
    providedIn: 'root'
})
export class FilterApi {

    constructor(private readonly api: Api) {}

    public async getSqlStringFromQuery(query) {
        return await this.api.http2.graphqlRequest(`
                query GetSql($query: QueryInput!) {
                    sql(query: $query)
                }
        `,                                         { query }, 'GET', 'sql');
    }

    public async getSqlStringFromQueryWithLayer(query, layerId) {
        return await this.api.http2.graphqlRequest(`
                query GetSql($query: QueryInput!) {
                    sql(query: $query, layerId: ${layerId})
                }
        `,                                         { query, layerId }, 'GET', 'sql');
    }
}
